// extracted by mini-css-extract-plugin
module.exports = {"policy":"Notification_policy__AMzdf","link":"Notification_link__2OVqN"};